import { render } from "./GameView.vue?vue&type=template&id=16b906cd&scoped=true"
import script from "./GameView.vue?vue&type=script&lang=js"
export * from "./GameView.vue?vue&type=script&lang=js"

import "./GameView.vue?vue&type=style&index=0&id=16b906cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b906cd"]])

export default __exports__